<button mat-fab color="primary" (click)="newRelease()" [disabled]="isProcessing">
  <mat-icon>add</mat-icon>
</button>
